import { render, staticRenderFns } from "./HomeInbound.vue?vue&type=template&id=572e05b1"
import script from "./HomeInbound.vue?vue&type=script&lang=js"
export * from "./HomeInbound.vue?vue&type=script&lang=js"
import style0 from "./HomeInbound.vue?vue&type=style&index=0&id=572e05b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports